import { Injectable } from '@angular/core';
import { PURCHASE_STATISTICS_API } from '../purchase-statistics.api';
import { PurchaseQuery as Query } from '../query/purchase-query.builder';
import { PurchaseStatistic } from '../types/purchase-statistic';

@Injectable()
export class PurchaseStatisticsRepository {

  constructor() {
  }

  async load(query: Query): Promise<{data: Partial<PurchaseStatistic[]>, pivotFields?: string[]}> {
    const response = await fetch(
      PURCHASE_STATISTICS_API, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Basic cXVlcnk6RFVFdVVWdmNSaXR1ODUxbUx3S2I='
        }),
        body: JSON.stringify(query)
      })

    if (!response.ok) {
      const body = await response.text().catch(() => '');
      throw new Error(`Unable to load data: ${response.status} ${response.statusText}${body ? ` — ${body}` : ''}`);
    }
    const data = await response.json();
    return data;
  }
}
